// Genere par node scripts/studio-natifs.mjs ; ne pas modifier a la main.
export const NATIFS_PAR_FAMILLE = {
  "absences": [
    "approvedByWorkerId",
    "archivedAt",
    "availabilityId",
    "bookingId",
    "couleur",
    "createdAt",
    "createdBy",
    "creditId",
    "deletedAt",
    "endAt",
    "id",
    "orgId",
    "photo",
    "schemaVersion",
    "shiftId",
    "startAt",
    "status",
    "type",
    "updatedAt",
    "updatedBy",
    "workerId"
  ],
  "accessGrants": [
    "archivedAt",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "granteeContactId",
    "id",
    "loanId",
    "orgId",
    "photo",
    "placeId",
    "portalRef",
    "resourceId",
    "revokedAt",
    "schemaVersion",
    "subscriptionId",
    "type",
    "updatedAt",
    "updatedBy",
    "validFrom",
    "validUntil"
  ],
  "agreements": [
    "archivedAt",
    "contactId",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "documentIds",
    "effectiveFrom",
    "effectiveUntil",
    "id",
    "invoiceId",
    "listingId",
    "obligations",
    "opportunityId",
    "orgId",
    "photo",
    "renewalTerms",
    "schemaVersion",
    "signedAt",
    "subscriptionId",
    "type",
    "updatedAt",
    "updatedBy"
  ],
  "assets": [
    "archivedAt",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "id",
    "label",
    "name",
    "orgId",
    "ownerContactId",
    "photo",
    "reference",
    "schemaVersion",
    "status",
    "type",
    "updatedAt",
    "updatedBy"
  ],
  "attendances": [
    "archivedAt",
    "bookingId",
    "checkInAt",
    "checkOutAt",
    "contactId",
    "couleur",
    "createdAt",
    "createdBy",
    "creditId",
    "deletedAt",
    "eventId",
    "id",
    "orgId",
    "photo",
    "policyId",
    "registrationId",
    "schemaVersion",
    "shiftId",
    "signedBy",
    "status",
    "type",
    "updatedAt",
    "updatedBy"
  ],
  "availabilities": [
    "archivedAt",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "exceptions",
    "id",
    "orgId",
    "photo",
    "placeId",
    "resourceId",
    "schemaVersion",
    "timezone",
    "type",
    "updatedAt",
    "updatedBy",
    "validFrom",
    "validTo",
    "weeklyRules",
    "workerId"
  ],
  "bookings": [
    "archivedAt",
    "contactId",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "endAt",
    "id",
    "orderId",
    "orgId",
    "photo",
    "resourceIds",
    "schemaVersion",
    "source",
    "startAt",
    "status",
    "type",
    "updatedAt",
    "updatedBy",
    "workerId"
  ],
  "campaigns": [
    "archivedAt",
    "audienceGroupIds",
    "audienceSnapshotContactIds",
    "channel",
    "content",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "id",
    "orgId",
    "photo",
    "scheduledAt",
    "schemaVersion",
    "stats",
    "type",
    "updatedAt",
    "updatedBy",
    "utmRef"
  ],
  "careRecords": [
    "archivedAt",
    "assetId",
    "bookingId",
    "contactId",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "documentId",
    "id",
    "measurementId",
    "nextDueAt",
    "orgId",
    "performedAt",
    "photo",
    "practitionerWorkerId",
    "schemaVersion",
    "type",
    "updatedAt",
    "updatedBy",
    "workOrderId"
  ],
  "compositions": [
    "archivedAt",
    "components",
    "computedCost",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "id",
    "orgId",
    "photo",
    "productId",
    "schemaVersion",
    "steps",
    "type",
    "updatedAt",
    "updatedBy",
    "yield"
  ],
  "consents": [
    "archivedAt",
    "campaignId",
    "channel",
    "contactId",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "givenAt",
    "id",
    "messageId",
    "orgId",
    "photo",
    "proofDocumentId",
    "relationshipId",
    "revokedAt",
    "schemaVersion",
    "scope",
    "textVersion",
    "type",
    "updatedAt",
    "updatedBy"
  ],
  "contacts": [
    "archivedAt",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "email",
    "firstName",
    "id",
    "lastName",
    "name",
    "orgId",
    "phone",
    "photo",
    "schemaVersion",
    "type",
    "updatedAt",
    "updatedBy"
  ],
  "credentials": [
    "alertBeforeDays",
    "archivedAt",
    "assetId",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "expiresAt",
    "id",
    "inspectionId",
    "issuedAt",
    "issuer",
    "orgId",
    "photo",
    "proofDocumentId",
    "schemaVersion",
    "taskId",
    "type",
    "updatedAt",
    "updatedBy",
    "workerId"
  ],
  "credits": [
    "archivedAt",
    "balance",
    "contactId",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "expiresAt",
    "holderKind",
    "id",
    "movements",
    "orderId",
    "orgId",
    "photo",
    "schemaVersion",
    "subscriptionId",
    "type",
    "unit",
    "updatedAt",
    "updatedBy"
  ],
  "custodies": [
    "archivedAt",
    "bookingId",
    "conditionInspectionIds",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "description",
    "dueBackAt",
    "id",
    "incidentId",
    "itemAssetId",
    "orgId",
    "ownerContactId",
    "photo",
    "receivedAt",
    "responsibleWorkerId",
    "returnedAt",
    "schemaVersion",
    "type",
    "updatedAt",
    "updatedBy",
    "workOrderId"
  ],
  "documents": [
    "archivedAt",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "expiresAt",
    "fileUrl",
    "id",
    "linkedRefs",
    "mimeType",
    "orgId",
    "photo",
    "schemaVersion",
    "size",
    "type",
    "updatedAt",
    "updatedBy",
    "version",
    "visibility"
  ],
  "donations": [
    "amount",
    "archivedAt",
    "campaignId",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "donorContactId",
    "id",
    "inKindDescription",
    "orgId",
    "paymentId",
    "photo",
    "projectId",
    "receiptNumber",
    "receivedAt",
    "recurringSubscriptionId",
    "schemaVersion",
    "type",
    "updatedAt",
    "updatedBy"
  ],
  "events": [
    "archivedAt",
    "campaignId",
    "capacity",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "endAt",
    "id",
    "orgId",
    "photo",
    "placeId",
    "price",
    "recurrenceRule",
    "registrationDeadline",
    "resourceId",
    "schemaVersion",
    "startAt",
    "type",
    "updatedAt",
    "updatedBy",
    "workerIds"
  ],
  "expenses": [
    "amount",
    "archivedAt",
    "category",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "id",
    "incurredAt",
    "invoiceId",
    "orgId",
    "paymentId",
    "photo",
    "projectId",
    "rebillable",
    "receiptDocumentId",
    "schemaVersion",
    "status",
    "type",
    "updatedAt",
    "updatedBy",
    "workerId"
  ],
  "forms": [
    "archivedAt",
    "bookingId",
    "consentId",
    "couleur",
    "createdAt",
    "createdBy",
    "custodyId",
    "deletedAt",
    "eventId",
    "id",
    "orgId",
    "photo",
    "reviewId",
    "schemaVersion",
    "sensitivity",
    "submittedAt",
    "submittedByContactId",
    "templateSchema",
    "templateVersion",
    "type",
    "updatedAt",
    "updatedBy"
  ],
  "groups": [
    "archivedAt",
    "capacity",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "id",
    "memberContactIds",
    "name",
    "orgId",
    "ownerWorkerId",
    "payerContactId",
    "photo",
    "schemaVersion",
    "type",
    "updatedAt",
    "updatedBy"
  ],
  "incidents": [
    "actionsTaken",
    "archivedAt",
    "closedAt",
    "couleur",
    "createdAt",
    "createdBy",
    "custodyId",
    "deletedAt",
    "description",
    "documentIds",
    "followUpTaskIds",
    "id",
    "inspectionId",
    "involvedRefs",
    "occurredAt",
    "orgId",
    "photo",
    "schemaVersion",
    "severity",
    "ticketId",
    "type",
    "updatedAt",
    "updatedBy"
  ],
  "inspections": [
    "archivedAt",
    "assetId",
    "checkpoints",
    "couleur",
    "createdAt",
    "createdBy",
    "custodyId",
    "deletedAt",
    "documentIds",
    "followUpTaskIds",
    "id",
    "incidentId",
    "orgId",
    "performedAt",
    "performedByWorkerId",
    "photo",
    "placeId",
    "schemaVersion",
    "templateId",
    "type",
    "updatedAt",
    "updatedBy",
    "verdict",
    "workOrderId"
  ],
  "invoices": [
    "archivedAt",
    "contactId",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "direction",
    "dueAt",
    "id",
    "lines",
    "number",
    "orderId",
    "orgId",
    "paymentId",
    "photo",
    "projectId",
    "schemaVersion",
    "status",
    "subscriptionId",
    "totalInclTax",
    "type",
    "updatedAt",
    "updatedBy"
  ],
  "listings": [
    "agreementId",
    "archivedAt",
    "assetId",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "id",
    "orgId",
    "photo",
    "placeId",
    "price",
    "publishedChannels",
    "schemaVersion",
    "status",
    "type",
    "updatedAt",
    "updatedBy"
  ],
  "loans": [
    "archivedAt",
    "billable",
    "borrowerContactId",
    "conditionInspectionIds",
    "conditionNotes",
    "couleur",
    "createdAt",
    "createdBy",
    "custodyId",
    "deletedAt",
    "dueBackAt",
    "id",
    "incidentId",
    "itemAssetId",
    "lentAt",
    "orderId",
    "orgId",
    "photo",
    "returnedAt",
    "schemaVersion",
    "type",
    "updatedAt",
    "updatedBy"
  ],
  "lots": [
    "archivedAt",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "expiresAt",
    "id",
    "lotNumber",
    "orgId",
    "photo",
    "productId",
    "quantity",
    "receivedMovementId",
    "schemaVersion",
    "supplierContactId",
    "type",
    "updatedAt",
    "updatedBy"
  ],
  "measurements": [
    "archivedAt",
    "assetId",
    "careRecordId",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "id",
    "inspectionId",
    "invoiceId",
    "measuredAt",
    "measuredByWorkerId",
    "metric",
    "orgId",
    "photo",
    "placeId",
    "schemaVersion",
    "type",
    "unit",
    "updatedAt",
    "updatedBy",
    "value",
    "workOrderId"
  ],
  "member": [
    "apps",
    "archivedAt",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "disabled",
    "displayName",
    "email",
    "id",
    "orgId",
    "orgRole",
    "personId",
    "photo",
    "portes",
    "schemaVersion",
    "updatedAt",
    "updatedBy",
    "userId"
  ],
  "messages": [
    "acces",
    "archivedAt",
    "auteur",
    "body",
    "bookingId",
    "campaignId",
    "channel",
    "contactId",
    "conversationId",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "deliveryStatus",
    "direction",
    "fromRef",
    "id",
    "invoiceId",
    "mentions",
    "orgId",
    "parentId",
    "photo",
    "reactions",
    "reviewId",
    "schemaVersion",
    "sentAt",
    "signeLia",
    "subject",
    "systeme",
    "texte",
    "threadRef",
    "ticketId",
    "toRefs",
    "type",
    "updatedAt",
    "updatedBy"
  ],
  "opportunities": [
    "agreementId",
    "archivedAt",
    "campaignId",
    "contactId",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "expectedCloseAt",
    "expectedValue",
    "id",
    "lostReason",
    "messageId",
    "orderId",
    "orgId",
    "ownerWorkerId",
    "photo",
    "probability",
    "schemaVersion",
    "source",
    "stage",
    "type",
    "updatedAt",
    "updatedBy"
  ],
  "orders": [
    "archivedAt",
    "contactId",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "direction",
    "id",
    "lines",
    "opportunityId",
    "orgId",
    "photo",
    "priceListId",
    "projectId",
    "schemaVersion",
    "status",
    "totalExclTax",
    "totalInclTax",
    "type",
    "updatedAt",
    "updatedBy",
    "validUntil"
  ],
  "organization": [
    "archivedAt",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "id",
    "locale",
    "name",
    "photo",
    "plan",
    "schemaVersion",
    "slug",
    "updatedAt",
    "updatedBy"
  ],
  "payments": [
    "amount",
    "archivedAt",
    "contactId",
    "couleur",
    "createdAt",
    "createdBy",
    "creditId",
    "deletedAt",
    "direction",
    "id",
    "invoiceIds",
    "last4",
    "method",
    "orderId",
    "orgId",
    "paidAt",
    "photo",
    "pspToken",
    "refundOfPaymentId",
    "schemaVersion",
    "subscriptionId",
    "type",
    "updatedAt",
    "updatedBy",
    "voucherId"
  ],
  "places": [
    "address",
    "archivedAt",
    "assetId",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "geo",
    "id",
    "isInternal",
    "managingAgreementId",
    "orgId",
    "ownerContactId",
    "parentPlaceId",
    "photo",
    "schemaVersion",
    "type",
    "updatedAt",
    "updatedBy"
  ],
  "policies": [
    "appliesToRefs",
    "archivedAt",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "domain",
    "effectiveFrom",
    "id",
    "orgId",
    "photo",
    "rules",
    "schemaVersion",
    "type",
    "updatedAt",
    "updatedBy",
    "version"
  ],
  "priceLists": [
    "appliesTo",
    "archivedAt",
    "couleur",
    "createdAt",
    "createdBy",
    "currency",
    "deletedAt",
    "id",
    "orgId",
    "photo",
    "priority",
    "promoCode",
    "rules",
    "schemaVersion",
    "type",
    "updatedAt",
    "updatedBy",
    "validFrom",
    "validTo"
  ],
  "products": [
    "archivedAt",
    "basePrice",
    "compositionId",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "durationMinutes",
    "id",
    "name",
    "orgId",
    "photo",
    "priceListId",
    "schemaVersion",
    "sku",
    "taxRate",
    "trackStock",
    "type",
    "unit",
    "updatedAt",
    "updatedBy",
    "variants"
  ],
  "projects": [
    "archivedAt",
    "budgetAmount",
    "budgetHours",
    "contactId",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "dueAt",
    "id",
    "managerWorkerId",
    "milestones",
    "orgId",
    "photo",
    "schemaVersion",
    "startAt",
    "status",
    "type",
    "updatedAt",
    "updatedBy"
  ],
  "recurrences": [
    "archivedAt",
    "avanceJours",
    "champDateEcheance",
    "champDateOccurrence",
    "champLibelle",
    "cibleType",
    "couleur",
    "createdAt",
    "createdBy",
    "curseur",
    "debut",
    "delaiEcheanceJours",
    "delaiNombre",
    "delaiUnite",
    "deletedAt",
    "dernierPassageAt",
    "dernierResultat",
    "derniereProduiteFamily",
    "derniereProduiteId",
    "derniereProduiteOccurrence",
    "description",
    "fin",
    "id",
    "jourDuMois",
    "journal",
    "joursSemaine",
    "mode",
    "modeleLibelle",
    "name",
    "nbProduites",
    "orgId",
    "photo",
    "prochaineOccurrence",
    "realisationChamp",
    "realisationDateChamp",
    "realisationValeurs",
    "rythmeIntervalle",
    "rythmeUnite",
    "sauts",
    "schemaVersion",
    "sourceId",
    "status",
    "templateId",
    "type",
    "updatedAt",
    "updatedBy"
  ],
  "registerSessions": [
    "archivedAt",
    "closedAt",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "id",
    "incidentId",
    "openedAt",
    "openedByWorkerId",
    "orgId",
    "paymentIds",
    "photo",
    "placeId",
    "schemaVersion",
    "status",
    "type",
    "updatedAt",
    "updatedBy"
  ],
  "registrations": [
    "archivedAt",
    "contactId",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "eventId",
    "groupId",
    "id",
    "orgId",
    "paymentId",
    "photo",
    "schemaVersion",
    "source",
    "status",
    "type",
    "updatedAt",
    "updatedBy",
    "waitlistPosition"
  ],
  "relationships": [
    "archivedAt",
    "consentId",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "endAt",
    "fromContactId",
    "groupId",
    "id",
    "isEmergencyContact",
    "orgId",
    "photo",
    "role",
    "schemaVersion",
    "startAt",
    "toContactId",
    "type",
    "updatedAt",
    "updatedBy"
  ],
  "resources": [
    "archivedAt",
    "assetId",
    "bookableOnline",
    "capacity",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "id",
    "name",
    "orgId",
    "photo",
    "placeId",
    "schemaVersion",
    "setupMinutes",
    "type",
    "updatedAt",
    "updatedBy"
  ],
  "reviews": [
    "archivedAt",
    "authorContactId",
    "bookingId",
    "comment",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "eventId",
    "id",
    "orderId",
    "orgId",
    "photo",
    "publishedAt",
    "rating",
    "replyMessageId",
    "schemaVersion",
    "ticketId",
    "type",
    "updatedAt",
    "updatedBy"
  ],
  "routes": [
    "archivedAt",
    "couleur",
    "createdAt",
    "createdBy",
    "date",
    "deletedAt",
    "id",
    "orgId",
    "photo",
    "proofDocumentIds",
    "schemaVersion",
    "shiftId",
    "status",
    "stops",
    "type",
    "updatedAt",
    "updatedBy",
    "vehicleAssetId",
    "workerId"
  ],
  "shifts": [
    "absenceId",
    "archivedAt",
    "availabilityId",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "endAt",
    "id",
    "orgId",
    "photo",
    "placeId",
    "roleLabel",
    "routeId",
    "schemaVersion",
    "startAt",
    "status",
    "type",
    "updatedAt",
    "updatedBy",
    "workerId"
  ],
  "shipments": [
    "archivedAt",
    "carrier",
    "contactId",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "deliveredAt",
    "destinationRef",
    "direction",
    "id",
    "inspectionId",
    "orderId",
    "orgId",
    "photo",
    "routeId",
    "scheduledAt",
    "schemaVersion",
    "status",
    "stockMovementId",
    "trackingNumber",
    "type",
    "updatedAt",
    "updatedBy"
  ],
  "stocks": [
    "archivedAt",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "id",
    "lotId",
    "orderId",
    "orgId",
    "photo",
    "placeId",
    "productId",
    "quantityOnHand",
    "quantityReserved",
    "reorderPoint",
    "schemaVersion",
    "type",
    "unit",
    "updatedAt",
    "updatedBy"
  ],
  "stockMovements": [
    "archivedAt",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "fromPlaceId",
    "id",
    "lotId",
    "movedAt",
    "orderId",
    "orgId",
    "photo",
    "productId",
    "quantity",
    "reason",
    "schemaVersion",
    "shipmentId",
    "toPlaceId",
    "type",
    "updatedAt",
    "updatedBy",
    "workOrderId"
  ],
  "subscriptions": [
    "agreementId",
    "archivedAt",
    "billingPeriod",
    "contactId",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "endAt",
    "id",
    "nextInvoiceAt",
    "orgId",
    "photo",
    "planRef",
    "productId",
    "renewalMode",
    "schemaVersion",
    "startAt",
    "status",
    "type",
    "updatedAt",
    "updatedBy"
  ],
  "tasks": [
    "archivedAt",
    "assigneeWorkerId",
    "contactId",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "dueAt",
    "id",
    "messageId",
    "orgId",
    "photo",
    "priority",
    "projectId",
    "recurrenceRule",
    "schemaVersion",
    "status",
    "ticketId",
    "type",
    "updatedAt",
    "updatedBy",
    "workOrderId"
  ],
  "tickets": [
    "archivedAt",
    "assignedWorkerId",
    "channel",
    "contactId",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "id",
    "orgId",
    "photo",
    "priority",
    "resolutionSummary",
    "schemaVersion",
    "slaDueAt",
    "status",
    "type",
    "updatedAt",
    "updatedBy"
  ],
  "timesheets": [
    "archivedAt",
    "billable",
    "contactId",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "durationMinutes",
    "id",
    "invoiceId",
    "orgId",
    "photo",
    "projectId",
    "schemaVersion",
    "shiftId",
    "startAt",
    "taskId",
    "type",
    "updatedAt",
    "updatedBy",
    "workOrderId",
    "workerId"
  ],
  "todos": [
    "archivedAt",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "dueAt",
    "id",
    "orgId",
    "photo",
    "priority",
    "schemaVersion",
    "status",
    "type",
    "updatedAt",
    "updatedBy"
  ],
  "vouchers": [
    "archivedAt",
    "code",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "expiresAt",
    "id",
    "initialValue",
    "issuedToContactId",
    "orgId",
    "photo",
    "redeemedRefs",
    "remainingValue",
    "schemaVersion",
    "type",
    "updatedAt",
    "updatedBy"
  ],
  "warranties": [
    "archivedAt",
    "assetId",
    "claimTicketIds",
    "couleur",
    "createdAt",
    "createdBy",
    "deletedAt",
    "durationMonths",
    "id",
    "orderLineRef",
    "orgId",
    "photo",
    "schemaVersion",
    "startAt",
    "terms",
    "type",
    "updatedAt",
    "updatedBy",
    "workOrderId"
  ],
  "workOrders": [
    "archivedAt",
    "assetId",
    "assignedWorkerId",
    "bookingId",
    "completedAt",
    "contactId",
    "couleur",
    "createdAt",
    "createdBy",
    "custodyId",
    "deletedAt",
    "diagnosis",
    "id",
    "inspectionId",
    "laborMinutes",
    "orderId",
    "orgId",
    "partLines",
    "photo",
    "placeId",
    "schemaVersion",
    "status",
    "ticketId",
    "type",
    "updatedAt",
    "updatedBy"
  ],
  "workers": [
    "archivedAt",
    "bookableOnline",
    "contactId",
    "couleur",
    "createdAt",
    "createdBy",
    "defaultPlaceId",
    "deletedAt",
    "id",
    "name",
    "orgId",
    "photo",
    "schemaVersion",
    "skills",
    "type",
    "updatedAt",
    "updatedBy"
  ]
};
export const NATIFS_REQUIS_PAR_FAMILLE = {
  "absences": [
    "workerId"
  ],
  "accessGrants": [
    "granteeContactId"
  ],
  "agreements": [
    "contactId"
  ],
  "assets": [
    "name"
  ],
  "attendances": [
    "contactId"
  ],
  "availabilities": [],
  "bookings": [],
  "campaigns": [],
  "careRecords": [],
  "compositions": [
    "productId"
  ],
  "consents": [
    "contactId",
    "scope"
  ],
  "contacts": [],
  "credentials": [],
  "credits": [
    "balance"
  ],
  "custodies": [],
  "documents": [
    "fileUrl"
  ],
  "donations": [],
  "events": [],
  "expenses": [
    "amount"
  ],
  "forms": [
    "sensitivity"
  ],
  "groups": [
    "name"
  ],
  "incidents": [],
  "inspections": [],
  "invoices": [
    "contactId"
  ],
  "listings": [],
  "loans": [
    "borrowerContactId",
    "itemAssetId"
  ],
  "lots": [
    "productId"
  ],
  "measurements": [
    "metric",
    "value"
  ],
  "member": [],
  "messages": [],
  "opportunities": [],
  "orders": [
    "contactId"
  ],
  "organization": [],
  "payments": [
    "amount"
  ],
  "places": [],
  "policies": [],
  "priceLists": [],
  "products": [
    "name"
  ],
  "projects": [],
  "recurrences": [
    "cibleType",
    "debut",
    "mode",
    "name",
    "rythmeUnite"
  ],
  "registerSessions": [
    "placeId"
  ],
  "registrations": [
    "contactId",
    "eventId"
  ],
  "relationships": [
    "fromContactId",
    "toContactId"
  ],
  "resources": [
    "name"
  ],
  "reviews": [
    "rating"
  ],
  "routes": [],
  "shifts": [
    "workerId"
  ],
  "shipments": [],
  "stocks": [
    "placeId",
    "productId"
  ],
  "stockMovements": [
    "productId",
    "quantity"
  ],
  "subscriptions": [
    "contactId"
  ],
  "tasks": [],
  "tickets": [],
  "timesheets": [
    "workerId"
  ],
  "todos": [],
  "vouchers": [
    "code"
  ],
  "warranties": [],
  "workOrders": [],
  "workers": [
    "name"
  ]
};
export const NATIFS_PERSONNE_PAR_FAMILLE = {
  "timesheets": [
    "workerId"
  ]
};
export const NATIFS_DE_TRACE = {
  "createdBy": "personne",
  "updatedBy": "personne",
  "createdAt": "date",
  "updatedAt": "date"
};
